import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDealerProducts } from "../../hooks/useDealerProducts";
import { useCart } from "../../hooks/useCart";
import Footer from "../../components/Footer";

const DealerProductsPage = () => {
  const { dealerId } = useParams();
  const { dealerProducts, dealerName, loading, error, refetchDealerProducts } =
    useDealerProducts(dealerId);
  const { addItemToCart } = useCart();
  const navigate = useNavigate();

  const [showAddedAlert, setShowAddedAlert] = useState(false);
  const [addedProductName, setAddedProductName] = useState("");

  const productsToShow = dealerProducts.filter(
    (p) => p.price && parseFloat(p.price) > 0
  );

  const DealerProductCard = ({ product }) => {
    const handleAddToCart = async (prod) => {
      console.log("Sepete Eklenecek Ürün:", prod);
      
      // Ürün bilgilerini hazırla
      const productInfo = {
        product_name: prod.product_name,
        dealer_name: dealerName,
        price: prod.price,
        product_unit: prod.product_unit,
        category_id: prod.category_id,
        category_name: prod.category_name,
        product_image_url: prod.product_image_url
      };
      
      try {
        const success = await addItemToCart(dealerId, prod.product_id, productInfo);
        
        if (success) {
          setAddedProductName(prod.product_name);
          setShowAddedAlert(true);

          setTimeout(() => {
            setShowAddedAlert(false);
            navigate("/sepetim");
          }, 1500);
        } else {
          // Hata durumunda kullanıcıya bilgi ver
          alert("Ürün sepete eklenemedi. Lütfen tekrar deneyin.");
        }
      } catch (err) {
        console.error("Sepete ekleme hatası:", err);
        alert("Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    };

    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 flex flex-col h-full shadow-sm hover:shadow-md transition-shadow duration-150">
        <h3
          className="text-sm sm:text-base font-semibold text-gray-800 mb-2 flex-grow line-clamp-2"
          title={product.product_name}
        >
          {product.product_name}
        </h3>
        <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-100">
          <span className="text-xs text-gray-500">{product.product_unit}</span>
          <span className="text-sm sm:text-base font-bold text-indigo-600">
            {product.price} TL
          </span>
        </div>
        <button
          onClick={() => handleAddToCart(product)}
          className="mt-3 w-full inline-flex items-center justify-center px-3 py-2 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          Sepete Ekle
        </button>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {showAddedAlert && (
        <div
          className="fixed top-20 right-4 z-50 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-md shadow-lg animate-bounce"
          role="alert"
        >
          <strong className="font-bold">Başarılı! </strong>
          <span className="block sm:inline">
            {addedProductName} sepete eklendi.
          </span>
        </div>
      )}

      <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full relative">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
            {loading ? "Yükleniyor..." : error ? "Hata" : dealerName} - Ürün ve
            Fiyat Listesi
          </h1>
          <div className="flex items-center gap-2 text-sm mt-2">
            <Link to="/" className="text-indigo-600 hover:underline">
              Anasayfa
            </Link>
            <span className="text-gray-400">/</span>
            <span className="text-gray-500">Bayiler</span>
            <span className="text-gray-400">/</span>
            <span className="text-gray-500 truncate max-w-xs">
              {dealerName}
            </span>
          </div>
        </div>

        {loading && (
          <p className="text-center text-gray-500 py-10">
            Ürünler yükleniyor...
          </p>
        )}
        {error && (
          <div className="text-center text-red-500 py-10">
            <p>Hata: {error}</p>
            <button
              onClick={refetchDealerProducts}
              className="mt-4 px-4 py-2 border border-red-300 text-red-600 rounded hover:bg-red-50"
            >
              Tekrar Dene
            </button>
          </div>
        )}

        {!loading && !error && productsToShow.length === 0 && (
          <div className="mt-8 p-6 border border-yellow-300 bg-yellow-50 rounded-lg text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-yellow-400 mx-auto mb-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="text-lg font-medium text-yellow-800">
              Hizmet Geçici Olarak Durduruldu
            </h3>
            <p className="mt-2 text-sm text-yellow-700">
              Bu bayimiz şu anda listelenen ürünler için fiyat belirtmemiş veya
              geçici olarak hizmet verememektedir. Lütfen daha sonra tekrar
              kontrol edin veya farklı bir bayi ile iletişime geçin.
            </p>
          </div>
        )}

        {!loading && !error && productsToShow.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6">
            {productsToShow.map((product) => (
              <DealerProductCard key={product.product_id} product={product} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default DealerProductsPage;
